import { Component } from '@angular/core';

import { MenuComponent } from '../menu.component';

@Component({
  selector: 'customer-menu-separator-item',
  templateUrl: './menu-separator-item.component.html',
  styles: [''],
})
export class MenuSeparatorItemComponent<T> {
  constructor(readonly menu: MenuComponent<T>) {}
}
